import { DialogContent, Modal } from "@mui/material"
import React from "react"

import { useModalDismiss } from "../../hooks/use-modal-dismiss"
import { appStore, DGPrompt } from "../../store/AppStore"

import { PromptContent } from "./PromptContent"

export const PromptModal = () => {
  const prompt = appStore((state) => state.prompt)
  const setPrompt = appStore((state) => state.setPrompt)

  return (
    <Modal
      open={!!prompt?.open}
      sx={{
        height: "100%",
        width: "100%",
        backgroundColor: "#1A2436",
        zIndex: 1303,
        "& > *": { transition: "none !important" }, // don't flash the screen
      }}
    >
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {prompt?.open ? (
          <Screen prompt={prompt} setPrompt={setPrompt} />
        ) : (
          <></>
        )}
      </DialogContent>
    </Modal>
  )
}

const Screen = ({
  prompt,
  setPrompt,
}: {
  prompt: DGPrompt
  setPrompt: (prompt?: DGPrompt) => void
}) => {
  useModalDismiss(() => {
    if (prompt) prompt.onClose()
    setPrompt(undefined)
  }, prompt.canClose)

  return <PromptContent prompt={prompt} />
}
